<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="map" class="icon"></b-icon>
            <span>Google Map</span>
            <button class="edit" @click="toggleEditStore()">
                <b-icon icon="pencil-fill"></b-icon>
            </button>
        </div>

        <div class="content">
            <div class="form" v-if="formData">
                <div class="google-map">
                    <iframe :src="displayData.google.map"></iframe>
                </div>

                <div class="mt-3">
                    <input type="text" 
                            class="input-field" 
                            :class="{ 'reader': !isEditStore, 'invalid': errorData.map.blank }"
                            maxlength="500"
                            placeholder="Google Map"
                            v-model="formData.google.map"
                            :readonly="!isEditStore" />
                    <div class="input-error-message" v-if="errorData.map.blank">โปรดใส่ลิงค์จาก Google Map</div>
                </div>

                <div class="mt-4 text-right" v-if="isEditStore">
                    <button class="btn btn-main" @click="saveMap()">บันทึก</button>
                    <button class="btn btn-grey-outline" @click="cancel()">ยกเลิก</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Helper from '@/resources/Helper';

export default {
    data() {
        return {
            isEditStore: false,
            displayData: null,
            formData: null,
            errorData: this.initValidateData()
        }
    },
    props: {
        fieldData: Object
    },
    watch: {
        fieldData(value) {
            this.setData(value);
        }
    },
    methods: {
        initValidateData() {
            return {
                map: { blank: false }
            }
        },
        toggleEditStore() {
            this.isEditStore = true;
        },
        setData(data) {
            this.displayData = data;
            this.formData = Helper.cloneObject(this.displayData);
        },
        saveMap() {
            if (this.validateData()) {
                this.isEditStore = false;
                this.displayData = Helper.cloneObject(this.formData);

                this.$emit('saveData', {
                    group: 'google',
                    data: this.displayData
                });
            }
        },
        validateData() {
            this.errorData = this.initValidateData();
            let valid = true;

            if (!this.formData.google.map.trim()) {
                this.errorData.map.blank = true;
                valid = false;
            }

            return valid;
        },
        cancel() {
            this.isEditStore = false;
            this.errorData = this.initValidateData();
            this.formData = Helper.cloneObject(this.displayData);
        }
    }
}
</script>